<template>
  <div
    class="article-item"
    @click="
      articleJumpLink({
        id,
        articleType,
        target,
        redirectLink,
        source: source || '',
      })
    "
  >
    <div class="like-wrap" v-if="showLikes">
      <div class="like-content">
        <em class="ico align-center" :style="getIcoOfBg('likeicon')"></em>
        <span class="num align-center">{{ likeTotal }}</span>
      </div>
    </div>
    <div
      class="article-item-left"
      :style="pic1 ? setBg(pic1) : getIcoOfBg('videolistpic')"
    ></div>
    <div class="article-item-right">
      <a-typography-paragraph
        class="text"
        :ellipsis="ellipsis"
        :content="title"
      ></a-typography-paragraph>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { setBg } from '@utiles/index';
import useArticleJumpLink from '@hooks/useArticleJumpLink';
import { getIcoOfBg } from '@config/siteConfig';
import { Typography } from 'ant-design-vue';
const props = defineProps({
  showLikes: {
    default: 0,
  },
  articleItemInfo: {
    required: true,
  },
  source: {
    default: '',
  },
});

const ellipsis = {
  rows: 2,
  expandable: false,
  onEllipsis: (e: boolean) => {
    console.log(e);
  },
};

const {
  PIC1: pic1,
  PIC2: pic2,
  TITLE: title,
  ARTICLE_GROUP_ID: id,
  REDIRECT_LINK: redirectLink,
  REDIRECT_TYPE: target,
  LIKE_TOTAL: likeTotal,
  ARTICLE_TYPE: articleType,
} = props.articleItemInfo;

const { articleJumpLink } = useArticleJumpLink();
</script>

<style lang="scss" scoped>
@import '@assets/scss/dimen.scss';
.article-item {
  position: relative;
  display: flex;
  flex-direction: column;
  background: $layercolor;
  width: 100%;
  height: 251px;
  box-sizing: border-box;
  border-radius: 14px;
  margin-bottom: 20px;
  .article-item-left {
    width: 100%;
    height: 152px;
    border-top-left-radius: 14px;
    border-top-right-radius: 14px;
    flex-shrink: 0;
  }
  .article-item-right {
    position: relative;
    width: 100%;
    flex: 1;
    padding: 20px;
    box-sizing: border-box;
    .text {
      line-height: 30px;
      white-space: pre-wrap;
      font-size: $fzNormal;
      color: $itemcolor;
      overflow: hidden;
    }
  }

  .like-wrap {
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    background: $layercolor;
    padding: 5px;
    font-size: $fzSmall;
    color: $tipscolor;
    .ico {
      display: inline-block;
      width: 17px;
      height: 17px;
      margin-right: 5px;
    }
  }
}

@media only screen and (min-height: 640px) and (orientation: landscape) {
  .article-item {
    height: calc(251px / $pcRate);

    border-radius: calc(14px / $pcRate);
    margin-bottom: calc(20px / $pcRate);
    .article-item-left {
      height: calc(152px / $pcRate);
      border-top-left-radius: calc(14px / $pcRate);
      border-top-right-radius: calc(14px / $pcRate);
    }
    .article-item-right {
      padding: calc(20px / $pcRate);

      .text {
        line-height: calc(30px / $pcRate);
        font-size: $fzNormalPc;
      }
    }

    .like-wrap {
      top: calc(10px / $pcRate);
      right: calc(10px / $pcRate);
      border-radius: calc(10px / $pcRate);
      padding: calc(5px / $pcRate);
      font-size: $fzSmallPc;
      .ico {
        width: calc(17px / $pcRate);
        height: calc(17px / $pcRate);
        margin-right: calc(5px / $pcRate);
      }
    }
  }
}
</style>
